import K_BannerUtility from "../templates/K_BannerUtility";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface BannerUtilityOptions extends ComponentOptions {
    iconType: string;
}

export class BannerUtility extends TemplateComponent {

    options: BannerUtilityOptions;

    constructor(options: BannerUtilityOptions) {
        super(K_BannerUtility, options);
    }

}
